import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { loginAdmin } from '../services/api';
import ChurchLogo from '../components/ChurchLogo';
import './AdminLogin.css';

export default function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const { token } = await loginAdmin({ email, password });
      localStorage.setItem('adminToken', token);
      navigate('/gestion-ecclesiale');
    } catch (err) {
      setError(
        err?.response?.data?.error || 'Identifiants invalides. Veuillez réessayer.'
      );
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-brand">
          <div className="login-brand__logo">
            <ChurchLogo size={52} color="#C9A84C" />
          </div>
          <p className="login-brand__eyebrow">Panneau d'administration</p>
          <h1 className="login-brand__title">MIPRECCH</h1>
        </div>

        <form className="login-form" onSubmit={handleSubmit} noValidate>
          <h2 className="login-form__heading">Connexion</h2>

          {error && <div className="login-error" role="alert">{error}</div>}

          <div className="login-field">
            <label className="login-label" htmlFor="email">
              Adresse e-mail
            </label>
            <input
              id="email"
              className="login-input"
              type="email"
              autoComplete="email"
              placeholder="contact@miprecch.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={loading}
            />
          </div>

          <div className="login-field">
            <label className="login-label" htmlFor="password">
              Mot de passe
            </label>
            <input
              id="password"
              className="login-input"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={loading}
            />
          </div>

          <button className="login-btn" type="submit" disabled={loading}>
            {loading ? 'Connexion…' : 'Se connecter'}
          </button>
        </form>
      </div>
    </div>
  );
}
